export default __webpack_public_path__ + "static/media/numeracy-example.6106c3d0.png";